import { useCallback, useState } from 'react';

import type { SegmentId } from '@hotjar/webapp/features/Recordings/types';

import { useSegmentReset } from '../use-segment-reset';
import type { FormMode } from './FormModeOption';

function isNotPredefinedSegment(segmentId: SegmentId) {
  return segmentId > 0;
}

function getDefaultFormMode(canUpdateSegment: boolean): FormMode {
  return canUpdateSegment ? 'update' : 'create';
}

export function useFormMode(
  segmentId: SegmentId | null,
): [FormMode, (newFormMode: FormMode) => void, boolean] {
  const canUpdateSegment = segmentId !== null && isNotPredefinedSegment(segmentId);
  const [formMode, setFormMode] = useState<FormMode>(getDefaultFormMode(canUpdateSegment));

  const resetFormMode = useCallback(() => {
    setFormMode(getDefaultFormMode(canUpdateSegment));
  }, [setFormMode, canUpdateSegment]);
  useSegmentReset(segmentId, resetFormMode);

  return [formMode, setFormMode, canUpdateSegment];
}
